<script>
  import CityCouncilMap from "./CityCouncilMap.svelte";
  import CityCouncilList from "./CityCouncilList.svelte";

  import { selectedDistrict } from "@stores/userData.js";
  import navigateToHash from "@helpers/navigateToHash.js";
</script>

<div class="wrapper">
  <div class="map--wrapper">
    <CityCouncilMap center={{ lng: -95.3698028, lat: 29.85 }} zoom={8.5} />
  </div>
  <div class="list-and-gradient">
    <div class="list--wrapper scrollbar-hidden" id="city-council-list">
      <CityCouncilList />
      <li
        class="bypass-button"
        class:inactive={$selectedDistrict}
        on:click={() => {
          selectedDistrict.set(null);
          navigateToHash("share-step-2", 0);
        }}
      >
        I'm not from Houston, let me proceed anyway please &darr;
      </li>
    </div>
  </div>
</div>

<style>
  .bypass-button {
    background: white;
    padding: 0.5rem;
    border-radius: 3px;
    box-shadow: 0px 2px 2px var(--accent-color);
    margin: 1rem;
    margin-top: 2rem;
    display: block;
    text-decoration: none;
    cursor: pointer;
    max-width: 400px;
    font-size: 0.8rem;
    width: max-content;
    margin: auto;
    margin-top: 2rem;
  }

  .wrapper {
    position: relative;
    margin: 2rem auto 0 auto;
    height: 80vh;
    min-height: 400px;
    width: 100%;
    max-width: 1068px;
    width: 100%;
    margin: auto;
    display: flex;
  }

  .map--wrapper {
    height: 100%;
    flex: 3;
    box-shadow: 0px 0px 3px rgba(var(--text-color-rgb), 0.5);
  }

  .map--wrapper,
  :global(.mapboxgl-map) {
    border-radius: 5px;
  }

  .list--wrapper {
    height: 100%;
    overflow: auto;
    padding-bottom: 20px;
    flex: 1;
  }

  .list-and-gradient {
    position: relative;
  }
  .list--wrapper {
    overflow: scroll;
  }

  .inactive {
    opacity: 0.65;
  }

  @media screen and (max-width: 768px) {
    .list--wrapper {
      flex-direction: row;
      display: flex;
    }
  }

  @media screen and (max-width: 768px) {
    .wrapper {
      flex-direction: column;
      /* height: 100%; */
    }
    .list--wrapper {
      height: auto;
      padding: 10px 0;
      margin-top: 1rem;
    }

    .bypass-button {
      transform: translateY(35px);
      display: none;
    }
  }
</style>
